// Native mobile app store URLs.
export const IOS_APP_STORE_URL = 'https://apps.apple.com/us/app/prosperiacrm/id6761391891?itscg=30200&itsct=apps_box_badge&mttnsubad=6761391891'
export const IOS_APP_STORE_BADGE_SRC = 'https://toolbox.marketingtools.apple.com/api/v2/badges/download-on-the-app-store/white/en-us?releaseDate=1778803200'
export const ANDROID_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.prosperiacrm.app'
export const ANDROID_PLAY_STORE_BADGE_SRC = '/icons/google-play-badge.svg'

export const IOS_BUNDLE_ID = 'com.prosperiacrm.app'
export const ANDROID_PACKAGE_NAME = 'com.prosperiacrm.app'

export const detectMobileOS = () => {
  if (typeof navigator === 'undefined') return 'unknown'
  const ua = navigator.userAgent || ''
  if (/android/i.test(ua)) return 'android'
  if (/iPad|iPhone|iPod/.test(ua) || (ua.includes('Mac') && 'ontouchend' in document)) return 'ios'
  return 'unknown'
}
